export const uniqueMajors: string[] = [
  "Business and Management",
  "Engineering",
  "Computer Science & Data Science",
  "Other Sciences & allied medicinal professions",
  "Fashion & Design",
  "Accounting and Finance",
  "Law",
  "Humanities & Social sciences",
  "Medicine & Pharma",
  "Performing & Creative arts",
  "Media and Journalism",
  "Hospitality",
  "Marketing",
  "Sports & Nutrition",
  "Architecture",
  "Mathematics",
  "Liberal Arts and Sciences",
  "Geography & Environmental Sciences",
  "Education",
  "Agriculture Forestry and food",
  "Languages & Linguistics",
  "Veterinary sciences",
  "Politics & Public Administration",
  "Philosophy & Religious studies",
  "Biology",
  "Other",
];